import { useEffect } from "react"
import { useRelayEnvironment } from "react-relay"
import { GraphQLSubscriptionConfig, OperationType, requestSubscription } from "relay-runtime"
import { RelayEnvironment } from "@/relay-environment"

const useConditionalSubscription = <TSubscriptionPayload extends OperationType = OperationType>(
  config: GraphQLSubscriptionConfig<TSubscriptionPayload>,
  opts?: { skip?: boolean },
) => {
  const environment = useRelayEnvironment()
  const skip = opts?.skip

  useEffect(() => {
    if (skip) return

    const { dispose } = requestSubscription(RelayEnvironment, config)
    return dispose
  }, [environment, config, skip])
}

export { useConditionalSubscription }
